module.exports = __webpack_public_path__ + "img/sv17.7d0755e0.svg";